import React, { useContext, useEffect, useState } from 'react'
import SmallImageCard from './smallImageCard'
import { Link } from 'react-router-dom'
import Skeleton from '../skeleton'
import {DeviceContext} from '../index'


const SectionSmall = ({heading,cards,catId,link,title,type}) => {

                     const [data,setData] = useState(cards)
                     const [loading,setLoading] = useState(false)
                     const [error,setError] = useState(null)
                     const [hydrating,setHydrating] = useState(true)
                     const {mobile,setMobile} = useContext(DeviceContext)

                   
     useEffect(()  => {
   
        const t= setTimeout(() => {
           setHydrating(false)
        }, 500);

        return () => clearTimeout(t)

     },[])




    useEffect(()  =>   {
          
         if (cards) {

           setLoading(false)
           return;
         }

         else {
            setLoading(true)
            const fetchData = async() => {
                try {
                  let limit =mobile ? 3:2;
                   setMobile(window.innerWidth > 768 ? false : true)
                 
                 
                      const res= await fetch(`https://www.teluguone.com/comedy/${type}?start=0&limit=${limit}&${type === "comedyGalleryCategoryJson.php" ? "gal_id" : type === "comedyVideoCategoryJson.php" ?  "vcat_id" : "cat_id"}=${catId}`)
                
                  if (!res.ok) throw new Error(`Response Was Not Ok`)
                  const result = await res.json()
                  let f_name=''
                  switch (type) {
                       case 'comedyVideoCategoryJson.php' :
                       f_name = 'comedy_video_category' 
                       break;

                       case 'comedyContentCategoryJson.php' :
                       f_name = "comedy_category" 
                       break;

                       case 'comedyGalleryCategoryJson.php' :
                       f_name = "comedy_gallery_categories" 
                       break;
                  
                    default:
                      break;
                  }
                 
                  setData(result[f_name])
                  setError(null)
                  setLoading(false)
                  
                } catch (error) {
                   setData(null)
                   setError(error.message)
                   setLoading(false)
                }
            }
             setData(null)
            
             fetchData()
         }



    },[])

  
  return (
   
   
                  
                          <><h4 className='individual-heading' >{heading} <Link to={link}>VIEW ALL</Link></h4> 
                            <div className='small-card-section'>
                             
                         
                           {(loading || hydrating) && Array(mobile ? 3 : 2).fill("0").map((__,index) => 
       
                               <div className='small-image-card' key={index}>
                                   <img src='/comedy/assets/images/error_img.webp'  alt="small-img"  />
                               <div className='content' style={{width:"100%"}}>     
                                     <Skeleton type="title" />
                                     <Skeleton type="title" />
                                   </div>
                             </div> )
                           } 

                           {  data && heading !== 'Chitti'  && data.map((item,index) => <SmallImageCard  hydrating={hydrating}  key={index} index={index} card={item} mobile={mobile} title={title} heading={heading}  />)         
                            }
                            {data && heading === 'Chitti'  &&
                             
                               <SmallImageCard hydrating={hydrating}  key={'Chitti'} index={0} card={data[0]} mobile={mobile} title={title} heading={heading}  />
                             }
                     
                          
                            {error && 
                            
                              <div className="json-loading-error-div">
                                <img loading="eager" src="/comedy/assets/images/json_error.png" alt="json_error" />
                              </div>

                            }
                           
                           </div>



                        </> 

  )             
}

export default SectionSmall;
